import {CommandActionPayload, CommandFailureActionPayload} from '../../shared/actions/abstract-actions';
import {Quote} from '../model/quote';
import {
    QuoteAddProductCommand,
    QuoteCommand,
    QuoteCreateCommand,
    QuoteEditCommand,
    QuoteEditProductCommand,
    QuoteProductCommand,
    QuoteRequestCommand
} from '../model/quote-commands';
import {createAction, props} from '@ngrx/store';

// helper:

interface QuoteSuccessResultActionPayload<C> extends CommandActionPayload<C> {
    quote: Quote;
}

// quote create

export const createQuote = createAction(
    '[Quote] Create',
    props<CommandActionPayload<QuoteCreateCommand>>()
);

export const createQuoteSuccess = createAction(
    '[Quote] Creation success',
    props<QuoteSuccessResultActionPayload<QuoteCreateCommand>>(),
);

export const createQuoteFailure = createAction(
    '[Quote] Creation failure',
    props<CommandFailureActionPayload<QuoteCreateCommand>>()
);

// quote delete

export const deleteQuote = createAction(
    '[Quote] Delete',
    props<CommandActionPayload<QuoteCommand>>()
);

export const deleteQuoteSuccess = createAction(
    '[Quote] Deletion success',
    props<CommandActionPayload<QuoteCommand>>()
);

export const deleteQuoteFailure = createAction(
    '[Quote] Deletion Failure',
    props<CommandFailureActionPayload<QuoteCommand>>()
);

// quote edit

export const editQuote = createAction(
    '[Quote] Edit',
    props<CommandActionPayload<QuoteEditCommand>>()
);

export const editQuoteSuccess = createAction(
    '[Quote] Edit success',
    props<QuoteSuccessResultActionPayload<QuoteEditCommand>>()
);

export const editQuoteFailure = createAction(
    '[Quote] Edit failure',
    props<CommandFailureActionPayload<QuoteEditCommand>>()
);

// quote add product

export const addProduct = createAction(
    '[Quote] Add product',
    props<CommandActionPayload<QuoteAddProductCommand>>()
);

export const addProductSuccess = createAction(
    '[Quote] Add product success',
    props<QuoteSuccessResultActionPayload<QuoteAddProductCommand>>()
);

export const addProductFailure = createAction(
    '[Quote] Add product error',
    props<CommandFailureActionPayload<QuoteAddProductCommand>>()
);

// quote edit product

export const editProduct = createAction(
    '[Quote] Edit Product',
    props<CommandActionPayload<QuoteEditProductCommand>>()
);

export const editProductSuccess = createAction(
    '[Quote] Edit Product success',
    props<QuoteSuccessResultActionPayload<QuoteEditProductCommand>>()
);

export const editProductFailure = createAction(
    '[Quote] Edit Product failure',
    props<CommandFailureActionPayload<QuoteEditProductCommand>>()
);

// quote delete product

export const deleteProduct = createAction(
    '[Quote] Delete Product',
    props<CommandActionPayload<QuoteEditProductCommand>>()
);

export const deleteProductSuccess = createAction(
    '[Quote] Delete Product success',
    props<QuoteSuccessResultActionPayload<QuoteProductCommand>>()
);

export const deleteProductFailure = createAction(
    '[Quote] Delete Product failure',
    props<CommandFailureActionPayload<QuoteProductCommand>>()
);

// quote request

export const request = createAction(
    '[Quote] Request',
    props<CommandActionPayload<QuoteRequestCommand>>()
);

export const requestSuccess = createAction(
    '[Quote] RequestSuccess',
    props<QuoteSuccessResultActionPayload<QuoteRequestCommand>>()
);

export const requestFailure = createAction(
    '[Quote] RequestFailure',
    props<CommandFailureActionPayload<QuoteRequestCommand>>()
);

// Select Action:

export const select = createAction(
    '[Quote] Select',
    props<CommandActionPayload<QuoteCommand>>()
);

// Add to Quote SideNav Layout

export const openAddToQuoteNav = createAction(
    '[Quote] Opened AddToQuoteNav'
)

export const closeAddToQuoteNav = createAction(
    '[Quote] Closed AddToQuoteNav'
)

export const openAddToQuoteMenu = createAction(
    '[Quote] Opened AddToQuoteMenu'
)

export const closeAddToQuoteMenu = createAction(
    '[Quote] Closed AddToQuoteMenu'
)

export const openCreateNewQuote = createAction(
    '[Quote] Opened CreateNewQuote'
)

export const closeCreateNewQuote = createAction(
    '[Quote] Closed CreateNewQuote'
)

export const openChooseQuote = createAction(
    '[Quote] Opened ChooseQuote'
)

export const closeChooseQuote = createAction(
    '[Quote] Closed ChooseQuote'
)

export const changeChosenQuote = createAction(
    '[Quote] Changed ChosenQuote',
    props<{chosenQuote: Quote}>()
)

export const deselectNewlyCreatedQuote = createAction(
    '[Quote] Deselect ChosenQuote'
)

export const removeChosenQuote = createAction(
    '[Quote] Removed ChosenQuote'
)

export const openQuoteListMenu = createAction(
    '[Quote] Opened QuoteListMenu'
)

export const closeQuoteListMenu = createAction(
    '[Quote] Closed QuoteListMenu'
)

export const closeAllSideNavs = createAction(
    '[Quote] Closed AllSideNavs'
)

export const openEditQuote = createAction(
    '[Quote] Opened EditQuote'
)

export const closeEditQuote = createAction(
    '[Quote] Closed EditQuote'
)

export const openRequestQuote = createAction(
    '[Quote] Opened RequestQuote'
)

export const closeRequestQuote = createAction(
    '[Quote] Closed RequestQuote'
)

export const openQuoteDetail = createAction(
    '[Quote] Opened QuoteDetail'
)

export const closeQuoteDetail = createAction(
    '[Quote] Closed QuoteDetail'
)

export const addToQuoteQuantity = createAction(
    "[Quote] Changed addToQuoteQuantity",
    props<{quantity: number}>()
)

export const openQuoteOrderComplete = createAction(
    "[Quote] Opened QuoteOrderComplete"
)

export const closeQuoteOrderComplete = createAction(
    "[Quote] Closed QuoteOrderComplete"
)

export const download = createAction(
    "[Quote] Download Quote",
    props<{quote: Quote}>()
)

export const downloadSuccess = createAction(
    "[Quote] Download Quote Success",
    props<{blob: Blob}>()
)

export const downloadFailure = createAction(
    "[Quote] Download Quote Failure",
    props<CommandFailureActionPayload<Quote>>()
)
